import React, { FC } from 'react';
import { doctrineAnalytics } from '../../utils/analyticsUtils';
import { Hyperlink } from '../../components/Hyperlink';
import styles from './header_logo_not_logged.module.scss';

type Props = {
  source: string;
};

export const HeaderLogoNotLogged: FC<Props> = ({ source, children }) => (
  <Hyperlink
    className={styles.logoNotLogged}
    href="/"
    source={source}
    onClick={() => {
      doctrineAnalytics('Nav DoctrineLogoClicked');
    }}
  >
    {children}
  </Hyperlink>
);
